import * as React from 'react';
import type SurfaceStore from '../interfaces/SurfaceStore';

const SurfaceStoreContext = React.createContext<SurfaceStore>(null as SurfaceStore);
SurfaceStoreContext.displayName = 'SurfaceStoreContext';

export const StoreContextProvider = SurfaceStoreContext.Provider;

/**
 * Hook that return the surface store in the current context.
 */
export function useSurfaceStore() {
    return React.useContext(SurfaceStoreContext);
}
